import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { VscEyeClosed } from "react-icons/vsc";
import { RxEyeOpen } from "react-icons/rx";
import {
  forgotPassword,
  login,
  verifyOtp,
} from "../../redux/services/authSlice";
import Otpverify from "../../models/Otpverify";
import ForgotPassword from "./ForgotPassword";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [getLoading, setGetLoading] = useState(false);
  const [getVerifyLoading, setGetVerifyLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [forgotPasswordModal, setForgotPasswordModal] = useState(false);
  const [forgotLoading, setForgotLoading] = useState(false);
  const [otpValue, setOtpValue] = useState({
    otp: "",
    // userType: "admin",
  });
  const initialValues = {
    uniqueId: "",
    password: "",
    userType: "admin",
  };
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;
  const validationSchema = Yup.object({
    uniqueId: Yup.string().email().required("Please Enter Your Email"),
    password: Yup.string()
      .matches(
        passwordRegex,
        "Must include uppercase, lowercase, number, and symbol."
      )
      .min(8, "Enter at least 8 characters")
      .required("Please Enter Your Password"),
  });
  const onSubmit = async (values) => {
    values.uniqueId = values.uniqueId.toLowerCase();
    setGetLoading(true);
    try {
      let response = await dispatch(login(values));
      if (response?.payload?.status === 200) {
        setConfirm(true);
        setEmail(response?.payload?.data?.email);
        resetForm();
      }
    } catch (err) {
    } finally {
      setGetLoading(false);
    }
  };
  const {
    handleChange,
    errors,
    touched,
    handleSubmit,
    resetForm,
    handleBlur,
    values,
  } = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit,
  });

  const handleChangeOTP = (e) => {
    const value = e.target.value;
    if (/[^0-9]/.test(value)) {
      return;
    }
    setOtpValue({
      ...otpValue,
      otp: value,
    });
  };
  const verifyOtpHandler = async () => {
    setGetVerifyLoading(true);
    try {
      if (otpValue.otp === "" && !otpValue.userType) {
        toast.warning("Fill up empty space", {
          autoClose: 2000,
          pauseOnHover: false,
        });
        return;
      }

      let response = await dispatch(verifyOtp(otpValue));
      if (response?.payload?.status === 200) {
        setConfirm(false);
        navigate(email ? `/reset-password?email=${email}` : "/");
        setEmail("");
      }
    } catch (error) {
    } finally {
      setGetVerifyLoading(false);
    }
  };
  const makeForgotPasswordRequest = async (email) => {
    let payload = { uniqueId: email, userType: "admin" };
    try {
      const response = await dispatch(forgotPassword(payload));
      return response;
    } catch (error) {
    }
  };
  const handleResendOTP = async () => {
    try {
      const response = await makeForgotPasswordRequest(email);
      if (response) {
        alert("OTP sent again to your email!");
      }
    } catch (error) {
      alert("Error resending OTP. Please try again.");
    } finally {
    }
  };
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setForgotLoading(true);
    try {
      const response = await makeForgotPasswordRequest(email);
      setForgotLoading(false);
      if (response) {
        setForgotPasswordModal(false);
        setConfirm(true);
        alert("Check your email for the reset link!");
      }
    } catch (error) {
    } finally {
      setForgotLoading(false);
    }
  };
  return (
    <div className="min-h-screen w-full bg-background flex items-center justify-center p-4 sm:p-6 lg:p-8 font-sans text-foreground">
      <div className="grid w-full max-w-5xl grid-cols-1 overflow-hidden rounded-xl border border-border bg-card shadow-theme lg:grid-cols-2">
        <div className="relative hidden flex-col justify-between overflow-hidden bg-gradient-to-br from-primary via-tertiary to-accent p-8 text-white lg:flex lg:p-10">
          <div className="absolute -right-16 -top-16 h-56 w-56 rounded-full border border-white/20" />
          <div className="absolute -bottom-20 -left-20 h-64 w-64 rounded-full border border-white/20" />
          <div className="relative">
            <p className="font-heading text-lg font-extrabold tracking-tight">Achiwon</p>
            <p className="mt-1 text-xs font-bold uppercase tracking-widest text-white/80">UPSC &amp; GPSC CSE</p>
          </div>
          <div className="relative">
            <h1 className="font-heading text-2xl xl:text-3xl font-bold tracking-tight text-balance">Grow with confidence</h1>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-white/85">Sign in to manage contests, courses, workshops and reports from one developer console.</p>
            <div className="mt-6 flex items-center gap-2">
              <span className="bef-badge !bg-card/15 !text-white">Secure</span>
              <span className="bef-badge !bg-card/15 !text-white">OTP verified</span>
            </div>
          </div>
          <p className="relative text-[11px] font-semibold text-white/70">© 2026 Achiwon. All rights reserved.</p>
        </div>
        <div className="bg-card p-5 sm:p-8 lg:p-10">
        <h2 className="font-heading text-xl sm:text-2xl font-bold text-primary text-center tracking-tight mb-1">
          Welcome Back!
        </h2>
        <p className="text-center text-sm text-muted-foreground mb-5 sm:mb-6">Sign In to your developer account</p>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="bef-label">Email</label>
            <input
              type="text"
              name="uniqueId"
              value={values.uniqueId}
              onBlur={handleBlur}
              onChange={handleChange}
              errors={errors}
              touched={touched}
              placeholder="Enter Your Email Address"
              autoComplete="off"
              className="bef-input"
            />
            {errors.uniqueId && touched.uniqueId && (
              <p className="mt-1 px-2 text-red-600 text-sm">
                {errors.uniqueId}
              </p>
            )}
          </div>
          <div className="mb-1">
            <label className="bef-label">Password</label>
            <div className="relative">
              <input
                type={show ? "text" : "password"}
                placeholder="Enter password"
                className="bef-input !pr-12"
                name="password"
                onBlur={handleBlur}
                value={values.password}
                onChange={handleChange}
                errors={errors}
                touched={touched}
                autoComplete="off"
              />
              <button
                type="button"
                onClick={() => setShow(!show)}
                className="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-primary rounded-e-xl focus:outline-none hover:text-accent transition-colors"
              >
                {show ? (
                  <VscEyeClosed title="Show Password" color="#5B6577" />
                ) : (
                  <RxEyeOpen title="Hide Password" color="#5B6577" />
                )}
              </button>
            </div>
            {errors.password && touched.password && (
              <p className="mt-1 px-2 text-red-600  text-sm">
                {errors.password}
              </p>
            )}
          </div>
          <div
            className="flex items-start justify-end ms-2 cursor-pointer"
            onClick={() => setForgotPasswordModal(true)}
          >
            <div className="text-primary text-sm font-bold hover:text-accent hover:underline transition-colors">
              <p>Forgot password?</p>
            </div>
          </div>
          <button
            type="submit"
            disabled={getLoading}
            className={`w-full min-h-[2.75rem] inline-flex items-center justify-center gap-2 rounded-xl bg-primary hover:bg-[#0d3678] text-white px-5 py-2.5 text-sm font-bold shadow-theme transition-all duration-300 mt-6 sm:mt-7 ${
              getLoading ? "opacity-90 cursor-wait pointer-events-none" : ""
            }`}
          >
            {getLoading ? (
              <span className="flex items-center justify-center gap-2 text-white">
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <span>Signing In...</span>
              </span>
            ) : (
              "Sign In"
            )}
          </button>
        </form>
      </div>
      </div>
      <div className={`${confirm === true ? "block" : "hidden"}`}>
        <Otpverify
          confirm={confirm}
          onClose={() => setConfirm(false)}
          getVerifyLoading={getVerifyLoading}
          email={email}
          otpValue={otpValue.otp || ""}
          handleChangeOTP={handleChangeOTP}
          handleOtpverify={verifyOtpHandler}
          handleResendOTP={handleResendOTP}
        />
      </div>
      {forgotPasswordModal && (
        <ForgotPassword
          setForgotPasswordModal={setForgotPasswordModal}
          forgotPasswordModal={forgotPasswordModal}
          handleForgotPassword={handleForgotPassword}
          email={email}
          setEmail={setEmail}
          forgotLoading={forgotLoading}
        />
      )}
    </div>
  );
};

export default Login;
